import apiService from './api/api.service';

const notesService = {
  async getAllNotes() {
    return await apiService.get('/notes');
  },

  async createNote(noteData) {
    return await apiService.post('/notes', noteData);
  },

  async updateNote(id, noteData) {
    return await apiService.put(`/notes/${id}`, noteData);
  },

  async togglePin(id) {
    return await apiService.patch(`/notes/${id}/pin`);
  },

  async deleteNote(id) {
    return await apiService.delete(`/notes/${id}`);
  }
};

export default notesService;
